<template>
    <div>
        <el-form :model="shopProduct" ref="shopProductForm" :rules="rules" label-width="80px" size="mini" :inline="true">
            <el-form-item label="商品名称" prop="productName">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.productName"></el-input>
            </el-form-item>
            <el-form-item label="商品货号" prop="productNumber">
                <el-input :disabled="stateDisabled" style="width: 130px" size="small" v-model="shopProduct.productNumber"></el-input>
                <el-button
                    :disabled="stateDisabled"
                    type="primary"
                    @click="genProductNum"
                    size="small"
                    style="margin-left: 10px; width: 60px"
                    >生成</el-button
                >
            </el-form-item>
            <el-form-item v-if="isSa" label="所属门店" prop="storeId">
                <GridSelectShop
                    style="width: 200px"
                    title="选择门店"
                    labelName="storeName"
                    labelValue="id"
                    :value="shopProduct.storeId"
                    :limit="1"
                    :disabled="stateDisabled"
                    size="small"
                    @getValue="getValueStoreId"
                    :columns="STORE_code"
                    :searchs="STORE_search"
                    dataListUrl="/shop/store/findList"
                    entityBeanName="shopStore"
                    queryEntityUrl="/shop/store/get"
                >
                </GridSelectShop>
            </el-form-item>
            <el-form-item label="商品价格" prop="shopPrice">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.shopPrice"></el-input>
            </el-form-item>

            <el-form-item label="商品分类" prop="takeoutCategoryId">
                <el-select style="width: 200px" :disabled="shopProduct.storeId == '' && isSa" v-model="shopProduct.takeoutCategoryId" placeholder="请选择" clearable size="small">
                    <el-tree node-key="id" :default-expanded-keys="expands" :data="takeoutCategoryList" :props="treeProps">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="node.label" :value="data.id"> </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="市场价格" prop="marketPrice">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.marketPrice"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="成本价格" prop="costPrice">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.costPrice"></el-input>-->
<!--            </el-form-item>-->
			
			<!--el-form-item label="推荐手机" prop="inviterMobile">
			    <el-input :disabled="stateDisabled" placeholder="请输入商品推荐人手机" style="width: 200px" size="small" v-model="shopProduct.inviterMobile"></el-input>
			</el-form-item-->
<!--            <el-form-item label="商品分类" prop="takeoutCategoryId">-->
<!--                <el-select style="width: 200px" :disabled="shopProduct.storeId == '' || stateDisabled" v-model="shopProduct.takeoutCategoryId" placeholder="请选择" clearable size="small">-->
<!--                    <el-tree node-key="id" :default-expanded-keys="expands" :data="takeoutCategoryList" :props="treeProps">-->
<!--                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">-->
<!--                            <el-option :label="node.label" :value="data.id"> </el-option>-->
<!--                        </div>-->
<!--                    </el-tree>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="商品类型" prop="productType">-->
<!--                <el-select size="small" style="width: 200px" v-model="shopProduct.productType" :disabled="stateDisabled">-->
<!--                    <el-option v-for="item of productType" :key="item.key" :label="item.value" :value="item.key"> </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="订单类型" prop="orderType">-->
<!--                <el-select size="small" style="width: 200px" :disabled="stateDisabled" v-model="shopProduct.orderType">-->
<!--                    <el-option v-for="isShow in orderTypeList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--			<el-form-item label="人气指数" prop="extendField1" v-if="shopProduct.productType == 1">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField1" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item label="权益价值" prop="extendField2" v-if="shopProduct.productType == 1">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField2" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
<!--            <el-form-item label="赠送积分" prop="giveScore" v-if="shopProduct.productType == 1">-->
<!--                <el-input style="width: 200px" size="small" placeholder="购买标准商品赠送" v-model="shopProduct.giveScore" :disabled="stateDisabled"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="所需积分" prop="productScore" v-if="shopProduct.productType == 2">-->
<!--                <el-input style="width: 200px" size="small" placeholder="购买积分商品所需" v-model="shopProduct.productScore" :disabled="stateDisabled"></el-input>-->
<!--            </el-form-item>-->
<!--			-->
<!--			<el-form-item label="商品折扣" prop="discount" v-if="shopProduct.productType == 1">-->
<!--			    <el-input style="width: 200px" size="small" placeholder="标准商品折扣" v-model="shopProduct.discount" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item label="商品折扣" prop="scoreDiscount" v-if="shopProduct.productType == 2">-->
<!--			    <el-input style="width: 200px" size="small" placeholder="积分商品折扣" v-model="shopProduct.scoreDiscount" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
			
<!--            <el-form-item label="结算价格" prop="settlePrice" v-if="shopProduct.productType == 1">-->
<!--                <el-input style="width: 200px" size="small" v-model="shopProduct.settlePrice" :disabled="stateDisabled"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="库存数量" prop="stockSize">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.stockSize"></el-input>
            </el-form-item>
            <el-form-item label="已售数量" prop="saleSize">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.saleSize"></el-input>
            </el-form-item>

            <el-form-item label="限购数量" prop="buyLimit">
                <el-input
                    :disabled="stateDisabled"
                    style="width: 200px"
                    size="small"
                    placeholder="请填写限购数量，0不限购"
                    v-model="shopProduct.buyLimit"
                ></el-input>
            </el-form-item>
            <el-form-item label="商品排序" prop="sort">
                <el-input-number
                    style="width: 200px"
                    v-model="shopProduct.sort"
                    size="small"
                    label=""
                    :disabled="stateDisabled"
                    :min="1"
                    :max="100"
                    :step="10"
                    :controls="true"
                    controls-position="both"
                >
                </el-input-number>
            </el-form-item>
<!--            <el-form-item label="是否精选" prop="isSelected">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isSelected">-->
<!--                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否推荐" prop="isRecommend">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isRecommend">-->
<!--                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="商品状态" prop="isShow">
                <el-select
                    :disabled="stateDisabled"
                    size="small"
                    style="width: 200px"
                    v-model="shopProduct.isShow"
                >
                    <el-option
                        v-for="isShow in productStatusEnumList"
                        :key="isShow.key"
                        :label="isShow.value"
                        :value="isShow.key"
                    > </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="是否包邮" prop="isFreightFree">-->
<!--                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isFreightFree">-->
<!--                    <el-option-->
<!--                        v-for="isFreightFree in isShowList"-->
<!--                        :key="isFreightFree.key"-->
<!--                        :label="isFreightFree.value"-->
<!--                        :value="isFreightFree.key"-->
<!--                    >-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="运费金额" prop="freightPrice" v-if="shopProduct.isFreightFree != 1">-->
<!--                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.freightPrice"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="商品主图" prop="productPic">
                <el-upload
                    :disabled="stateDisabled"
                    style="width: 200px"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                >
                    <img v-if="shopProduct.productPic" :src="shopProduct.productPic" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, upload } from '@/utils/request.js';
import { STORE, STORE_SEARCH } from '@/utils/constant.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectShop,
    },
    data() {
        return {
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
            productStatusEnumList: [], //商品状态枚举
            orderTypeList: [],
            productType:[],
            shopProduct: {
                id: '', //Id
                productName: '', //商品名称
                productNumber: '', //商品货号
                shopPrice: '', //本店价格
                supplyPrice: '', //供货价格
                marketPrice: '', //市场价格
                buyLimit: '',
                productPic: '', //图片
                takeoutCategoryId: '',
                categoryId: '', //产品分组id
                brandId: '', //品牌Id
                productType: 1, //是否是积分商品
                productScore: 0, //产品所需积分
                giveScore:0,//赠送积分
				discount:1,//标准商品折扣
				scoreDiscount:1,//积分商品折扣
                sort: '10', //排序
                isShow: 1, //是否显示
                stockSize: '', //库存数量
                saleSize: '', //产品销量
                isFreightFree: 1, //是否免运费 1：是 0：否
                isSelected: 0,//是否精选
                isRecommend:0,//是否推荐
                freightPrice: '', //运费
                category: {},
                orderType: '',
                isSupply: 0,
                shopId: '',
                storeId: '',
                costPrice: 0, //成本价
				inviterMobile:'',
                shopCategoryId: '',
                buyMinLimit: '',
                wholesalePrice: ''
            },

            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                shopPrice: [{ required: true, message: '本店价格不能为空', trigger: 'blur' }],
                supplyPrice: [{ required: true, message: '供货价格不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品类目不能为空', trigger: 'blur' }],
                stockSize: [{ required: true, message: '库存数量不能为空', trigger: 'blur' }],
                isFreightFree: [{ required: true, message: '是否免运费不能为空', trigger: 'blur' }],
                isSelected: [{ required: true, message: '是否精选不能为空', trigger: 'blur' }],
                isRecommend: [{ required: true, message: '是否推荐不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否上架不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                saleSize: [{ required: true, message: '已售不能为空', trigger: 'blur' }],
                productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                freightPrice: [{ required: true, message: '运费不能为空', trigger: 'blur' }],
                buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }],
                productScore: [{ required: true, message: '所需积分不能为空', trigger: 'blur' }],
                giveScore: [{ required: true, message: '赠送积分不能为空', trigger: 'blur' }],
                orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur'  }],
                productType: [{ required: true, message: '商品类型不能为空', trigger: 'blur' }],
                shopCategoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
                takeoutCategoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
                storeId: [{ required: true, message: '所属门店不能为空', trigger: 'blur' }],
            },
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            isShowList: [], //是否上架
            stateDisabled: false,
            expands: [],
            takeoutCategoryList: [],
            isSa: 0
        };
    },
    watch:{
        // 'shopProduct.shopId':{
        //     handler(newVal, oldVal) {
        //         this.getSaleMode()
        //     },immediate: true,deep: true
        // }
    },
    created() {
        eventBus.$on('shopStoreTakeoutProduct', (data, state) => {
            // 不改变原组件的值
            console.log(data, state);
            this.shopProduct = { ...this.shopProduct, ...data };
            this.getTakeOutProductCategory(this.shopProduct.storeId);

            this.$forceUpdate();
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }

            // :disabled="shopProductState == 'check'"
        });
    },
    mounted() {
        this.getIsShowList();
        this.getProductType();
        this.getProductStatusEnum();
        this.getorderTypeList();
        this.getIsSa();
    },
    methods: {
        //是否上架
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },

        getIsSa(){
            get('/mpp/user/getIsSa').then(res=>{
                if(res.success){
                    this.isSa=res.isSa;
                    if(!res.isSa){
                        this.getTakeOutProductCategory();
                    }
                }
            })
        },

        getValueStoreId(value){
            this.shopProduct.storeId = value;
            this.shopProduct.takeoutCategoryId = "";
            this.getTakeOutProductCategory(value);
        },

        getorderTypeList() {
            get(`/shop/utils/getEnum`, { enumType: `takeout_order_type` }).then((res) => {
                if (res.success) {
                    this.orderTypeList = res.enumList;
                }
            });
        },
        //生成货号，货号不能为空
        genProductNum() {
            let dateTime;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            dateTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
            this.shopProduct.productNumber = dateTime;
        },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.shopProduct.productPic = res.url;
                    console.log(this.shopProduct.productPic);
                }
            });
        },
        validateForm() {
            let flag = true;
            this.$refs.shopProductForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },
        getTakeOutProductCategory(id){
            get(`/shop/storetakeoutproductcategory/findAll`,{
                storeId:id
            }).then((res)=>{
                if(res.success){
                    this.takeoutCategoryList = res.list
                }
            })
        },
        getProductType(){
            get("/mpp/utils/getEnum",{enumType:"product_type"}).then((res)=>{
                if(res.success && res.code == 200){
                    this.productType = res.enumList
                    console.log('this.productType',this.productType);
                }
            })
        },
        // 获取商品状态枚举
        getProductStatusEnum(){
            get('/shop/utils/getEnum',{
                enumType:'takeout_product_status',
            }).then((res)=>{
                if(res.success){
                    this.productStatusEnumList = res.enumList
                }
            })
        },
        // 计算商品状态
        computeProductStatus(type){
            for (let i = 0; i < this.productStatusEnumList.length; i++) {
                if(this.productStatusEnumList[i].key == type){
                    return this.productStatusEnumList[i].value
                }
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px !important;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>
